import { Currency } from '../Currency';

export enum PreAuthorizationStatus {
  ACTIVE = 'ACTIVE',
  CREATED = 'CREATED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  FULLY_CHARGED = 'FULLY_CHARGED',
  PARTIALLY_CHARGED = 'PARTIALLY_CHARGED',
  RELEASED = 'RELEASED',
}

export interface PreAuthorization {
  actionsAvailable: boolean;
  amountAuthorized: number;
  createdAt: string;
  currency: Currency;
  expiresAt: string | null;
  gatewayPreAuthId: string;
  orderUid: string;
  remainingAmount: number;
  startAt: string;
  status: PreAuthorizationStatus;
  statusLabel: string;
  uid: string;
  updatedAt: string;
}

export interface PreAuthorizationChargePayload {
  amount: number;
}
